module.exports = __webpack_public_path__ + "img/F961.0b17d6b8.jpg";